import { render, staticRenderFns } from "./PotentialPerson.vue?vue&type=template&id=0d9d7c92&scoped=true&"
import script from "./PotentialPerson.vue?vue&type=script&lang=js&"
export * from "./PotentialPerson.vue?vue&type=script&lang=js&"
import style0 from "./PotentialPerson.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PotentialPerson.vue?vue&type=style&index=1&id=0d9d7c92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9d7c92",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ExperiencesTable: require('/workspace/components/Experiences/ExperiencesTable.vue').default})
